import React, { FC, Fragment } from 'react';
import { Button } from '@cokitchen/cokitchen-components';
import { useLocation, useNavigate } from 'react-router-dom';
import RequestStatusTag from 'components/base/request-status-tag';
import { RequestType } from 'models/item-request.model';
import useKitchenItemRequestContext from 'contexts/kitchen/item-request.context/context';
import { MAIN_STORE_ROUTE_KEYS } from 'utils/constants';
import { ENUM_REQUEST_STATUS } from 'models/common.model';
import moment from 'moment';
import { formatCurrency } from 'utils/functions';

type Props = {
  request: RequestType;
};

const RequestCard: FC<Props> = ({ request }) => {
  const orderCode = request.id;
  const { setItemRequestToEdit } = useKitchenItemRequestContext();
  const router = useNavigate();
  const { pathname } = useLocation();
  const type = pathname.includes('kitchen') ? 'kitchen' : 'brand';
  const viewRequest = () => {
    const parentRoutes = {
      kitchen: MAIN_STORE_ROUTE_KEYS.KITCHEN_MANAGE_ITEM_REQUESTS,
      brand: MAIN_STORE_ROUTE_KEYS.MANAGE_MEALS
    };

    setItemRequestToEdit(request);

    const viewUrl: Partial<Record<ENUM_REQUEST_STATUS, string>> = {
      [ENUM_REQUEST_STATUS.REJECTED]: `${parentRoutes[type]}/update-rejected/${orderCode}`,
      [ENUM_REQUEST_STATUS.RECEIVED]: `${parentRoutes[type]}/report`,
      [ENUM_REQUEST_STATUS.REVIEWED]: `${parentRoutes[type]}/completed/${orderCode}`,
      [ENUM_REQUEST_STATUS.SENT]: `${parentRoutes[type]}/sent/${orderCode}`
    };
    router(viewUrl[request.status] || `${parentRoutes[type]}/${orderCode}`);
  };

  return (
    <Fragment>
      <div className='border hover:bg-gray-11 border-gray-13 rounded-lg flex flex-col py-2 w-full'>
        <div className='grow'>
          <div className='flex border-b border-[#ECEDEF] pb-2 items-center gap-2 flex-wrap justify-between px-3'>
            <h4 className='font-medium text-base cursor-pointer'>#{request.code}</h4>
            <RequestStatusTag status={request.status} />
          </div>

          <div className='p-3 text-sm '>
            {request.items.map((item, i) => (
              <div key={i} className='flex  items-center '>
                <p>{item.ingredient.name} </p>
                <div className='bg-[#DCDBD5] inline-block mx-1 w-[5px] h-[5px]  rounded-full' />
                <p className='text-sm text-gray-5'>
                  {item.quantity_requested}
                  {item.ingredient.unit_type || 'portions'} (
                  <span>
                    {formatCurrency(
                      Number(item.quantity_requested) * Number(item.ingredient.min_vendor_price)
                    )}
                  </span>
                  )
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className='flex border-t border-[#ECEDEF] pb-2 text-xs items-center gap-2 flex-wrap justify-between mx-3 pt-2'>
          <p>Created {moment(request?.created_at)?.format('Do MMM, YYYY [at] h:mm A')}</p>
          <Button className='text-xs' color='primary' variant='link' onClick={() => viewRequest()}>
            See all
          </Button>
        </div>
      </div>
    </Fragment>
  );
};

export default RequestCard;
